import { render, staticRenderFns } from "./ScheduleBoard.vue?vue&type=template&id=6ce09d76&"
import script from "./ScheduleBoard.vue?vue&type=script&lang=js&"
export * from "./ScheduleBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports